import React from 'react';
import { useLocation } from 'react-router-dom';
import { Nav } from 'react-bootstrap';
import { NavLink } from '../../../../Router';
import { NavLinkIcon } from '../../../atoms/navigation/NavLinkIcon';
import { NavLinkLabel } from '../../../atoms/navigation/NavLinkLabel';
import classNames from 'classnames';
import { MenuItemType } from '../types';
import { NavItemWithSubItems } from '../NavItemWithSubItems/NavItemWithSubItems';

export type NavItemProps = {
  menuItem: MenuItemType;
  //Navigational Item is each item that will navigate to a new route
  onNavigationalItemClick?: () => void;
};

const isPathnameActive = (pathname: string, routeTemplate: string): boolean =>
  pathname === routeTemplate ||
  new RegExp(
    `^${routeTemplate.replace(/\//g, '\\/').replace(/:[\w]+/g, '[^/]+')}$`,
  ).test(pathname);

export const NavItem: React.FC<NavItemProps> = ({
  menuItem,
  onNavigationalItemClick,
}) => {
  const { pathname } = useLocation();
  const route = menuItem.route;
  const isActive = Boolean(
    route &&
      (menuItem.routeParams
        ? pathname === route.create(menuItem.routeParams).split('?')[0]
        : isPathnameActive(pathname, route.template())),
  );

  if (!menuItem.shouldRender) {
    return null;
  }

  if (menuItem.subItems) {
    return (
      <NavItemWithSubItems
        menuItem={menuItem}
        onSubNavItemClick={onNavigationalItemClick}
      />
    );
  }

  return (
    <Nav.Item onClick={onNavigationalItemClick}>
      <NavLink
        exact={menuItem.route?.template() === '/'}
        to={menuItem.route}
        {...(menuItem.routeParams || {})}
        className={classNames('nav-link', 'd-flex', 'align-items-center')}>
        <NavLinkIcon isActive={isActive}>
          {isActive ? menuItem.activeIcon : menuItem.icon}
        </NavLinkIcon>
        <NavLinkLabel data-testid={menuItem.label}>
          {menuItem.label}
        </NavLinkLabel>
        {menuItem.suffix}
      </NavLink>
    </Nav.Item>
  );
};
